import React, { useEffect } from 'react';
import { array, func } from 'prop-types';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import shave from 'shave';

import MediaImage from '@blueberry/components/MediaImage';

import { generatePostURL } from '@blueberry/redux/navigation';
import { abbrivationFormat } from '@blueberry/utils/datetime';

import styles from './TrendBlock.scss';

const mapStateToProps = state => ({
  getPostURL: generatePostURL(state),
});
function TrendBlock({ posts, t, getPostURL }) {
  useEffect(() => {
    shave(`.${styles.title}`, 40, {
      spaces: false,
    });
    shave(`.${styles.headingPostTitle}`, 80, {
      spaces: false,
    });
  }, []);

  const renderPosts = (post, index) => {
    const {
      type,
      mediaUrl,
      introText,
      title,
      publishDate,
      mediaAltText,
      id,
      urlTitle,
      durationTime,
      authorName,
    } = post;

    const postUrl = getPostURL({ title: urlTitle, id });
    const orderString = `${index + 1}`.padStart(2, '0');
    const isFirstPost = index === 0;

    return (
      <li className={styles.postListItem} key={title}>
        <div className={styles.info}>
          <h3 className={styles.order}>{orderString}</h3>
          <div>
            <a className={styles.postLink} href={postUrl}>
              <h2
                className={isFirstPost ? styles.headingPostTitle : styles.title}
              >
                {title}
              </h2>
            </a>

            <p className={styles.description}>{introText}</p>

            <p className={styles.time}>
              <span>{authorName}</span>
              <span className={styles.dot} />
              <span>{abbrivationFormat(publishDate)}</span>
            </p>
          </div>
        </div>
        <div className={styles.thumbnail}>
          <MediaImage
            mediaAltText={mediaAltText}
            durationTime={durationTime}
            mediaUrl={mediaUrl}
            type={type}
            href={postUrl}
          />
        </div>
      </li>
    );
  };
  return (
    <div className={styles.root}>
      <h2 className={styles.title}>{t('home:home.trending.title')}</h2>
      <ul className={styles.postList}>{posts.map(renderPosts)}</ul>
    </div>
  );
}

TrendBlock.propTypes = {
  getPostURL: func.isRequired,
  posts: array.isRequired,
  t: func.isRequired,
};

export default connect(mapStateToProps)(translate(['home'])(TrendBlock));



// WEBPACK FOOTER //
// ./app/containers/Home/components/TrendBlock/TrendBlock.jsx